import { InjectionToken } from '@angular/core';

export const FiStateSrefClickHandler = new InjectionToken('FiStateSrefClickHandler');
export const FiStateSrefNavigateCheck = new InjectionToken('FiStateSrefNavigateCheck');
